import { getLocalStorageItem } from 'utils/browserCache';
import { getUrlParams } from 'utils/url';
import { MojoContextType } from 'utils/chatContext/types';
import { URL_PATHNAME } from 'constants/url';
import { LOCAL_STORAGE_KEY } from 'constants/browserCache';

/**
 * Get vehicleId to pass to AI Engine via chatContext. May be formatted differently between Carvana apps.
 * Apply custom extraction logic accordingly.
 */
export const getVehicleId = () => {
  const urlPath = window.location.pathname;
  if (urlPath) {
    if (urlPath.includes(URL_PATHNAME.VDP)) {
      /**
       * String match to align with VDP conventions
       * Example URL 1: https://testazure.carvana.com/vehicle/991333
       * Example URL 2: https://testazure.carvana.com/vehicle/lt/991333?utm_content=hero_cta&utm_medium=engagement&utm_source=email&utm_campaign=price_drop
       */
      let urlVehicleId = null;
      const fragments = urlPath.slice(1).split('/');
      if (fragments) {
        const isLiteUrl = fragments[1].toLowerCase() === 'lt';
        urlVehicleId = isLiteUrl ? fragments[2] : fragments[1];
      }
      return urlVehicleId;
    } else if (urlPath.includes(URL_PATHNAME.PURCHASE)) {
      /**
       * Hacky logic to support URLs at entry into Purchase Page.
       * Hopefully deprecate or improve in future:
       *
       * A) If entering from VDP/"My Order"/"VEHICLE DETAILS" in header drop-down menu, URL searchParams will quickly shift
       * from ?stock-number to ?vehicle-id. This stock-number does NOT represent vehicle-id but can be passed as a backup anyway.
       *
       * B) If entering from "MY CARS" in header drop-down menu, URL has HTML encoding (? to %3F) and is not formatted
       * properly for searchParams. Use regex to extract stock-number. This stock-number DOES represent vehicle-id.
       *
       * C) If entering from home page "CONTINUE PURCHASE" hero element, URL will not contain a stock-number or vehicle-id. Must save and persist
       * that value if/when previously entered from A) or B), then reference value saved in cache. If accessing
       * cross-device/browser where user is logged in both instances, vehicleId will never populate until entry is via A) or B).
       *
       */
      const stockNumParamCaseA = getUrlParams('stock-number');
      const stockNumRegexCaseB = /%3Fstock-number=(\d+)/;

      const stockNumRegexMatchCaseB = stockNumRegexCaseB.exec(urlPath);
      const stockNumberCaseAorB = stockNumRegexMatchCaseB
        ? stockNumRegexMatchCaseB[1]
        : stockNumParamCaseA;

      const vehicleIdCacheCaseC = getLocalStorageItem(LOCAL_STORAGE_KEY.CVNA_CHAT_UI);
      const vehicleIdCaseC = vehicleIdCacheCaseC?.vehicleIdPurchase;

      return getUrlParams('vehicle-id') || stockNumberCaseAorB || vehicleIdCaseC || null;
    }
  }
  return null;
};

export const getVehicleContext = (cachedMojoContext: MojoContextType) => {
  const vehicleId = getVehicleId();
  if (vehicleId) {
    return { src_vehicle_id: vehicleId };
  }
  if (cachedMojoContext) {
    const cachedVehicleId = cachedMojoContext?.info?.vehicle?.src_vehicle_id;
    if (cachedVehicleId) {
      return { src_vehicle_id: cachedVehicleId };
    }
  }
  return undefined;
};
